<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      v-if="showForm.basic"
      :close-on-click-modal="false"
      title="设备详情"
      width="500"
      @close="close"
    >
    <el-row>
      <el-col :span="5">ID:</el-col>
      <el-col :span="19">{{ showForm.deviceId }}</el-col>
    </el-row>
      <el-row>
        <el-col :span="5">标题:</el-col>
        <el-col :span="19">{{ showForm.title }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">小程序码:</el-col>
        <el-col :span="19"> <img :src="showForm.basic.qrcode" class="qrcode"></el-col>
      </el-row>
      <!--
      <el-row>
        <el-col :span="5">免费体验时间:</el-col>
        <el-col :span="19">{{ showForm.basic.freeTime }}分钟</el-col>
      </el-row>
    -->
      <el-row>
        <el-col :span="5">位置:</el-col>
        <el-col :span="19">
          {{ showForm.basic.address }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">扫码次数:</el-col>
        <el-col :span="19">
          {{ showForm.basic.totalVisitCount }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">使用次数:</el-col>
        <el-col :span="19">
          {{ showForm.basic.totalRecordCount }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">imei:</el-col>
        <el-col :span="19">
          {{ showForm.basic.imei }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">pwd:</el-col>
        <el-col :span="19">
          {{ showForm.basic.pwd }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">mp:</el-col>
        <el-col :span="19">
          {{ showForm.basic.mp }}
        </el-col>
      </el-row>
      <!--
      <el-row>
        <el-col :span="5">pubKey:</el-col>
        <el-col :span="19">
          {{ showForm.basic.pubKey }}
        </el-col>
      </el-row>
      -->
      <el-row>
        <el-col :span="5">备注:</el-col>
        <el-col :span="19">
          {{ showForm.basic.text || '无' }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">开启状态:</el-col>
        <el-col :span="19">
          {{ formatStartState(showForm) }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">状态:</el-col>
        <el-col :span="19">
          <el-tag v-if="showForm.step === 1">待发布</el-tag>
          <el-tag v-if="showForm.step === 2" type="success">已发布</el-tag>
          <el-tag v-if="showForm.step === 3" type="danger">已下架</el-tag>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">创建时间:</el-col>
        <el-col :span="19">
          {{ moment(showForm.created).format('YYYY-MM-DD HH:mm:ss') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">修改时间:</el-col>
        <el-col :span="19">
          {{ showForm.updated && moment(showForm.updated).format('YYYY-MM-DD HH:mm:ss') || '无' }}
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import config from './config'
import { findDevice } from '@/api/alfmeier'
export default {
  name: 'AlfmeierDeviceDetail',
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      showForm: {},
      row: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    formatStartState(row) {
      const state = config.startStates.find(e => e.value == row.basic.startState)
      return state && state.label || '未知'
    },
    async show(row) {
      const deviceId = row.deviceId
      this.row = row
      const data = await findDevice({
        deviceId,
        simple: 1, // 不同步硬件状态
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
.qrcode {
  width: 200px;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
}
</style>
